import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { breakpoint } from '~/styles/themes';

export const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    position: fixed;
    z-index: ${theme.zIndex.modal};
    top: 50%;
    left: 50%;
    align-items: center;
    justify-content: center;
    width: 343px;
    max-width: calc(${breakpoint.mobile_large} - 16px * 2);
    height: 727px;
    min-height: 700px;
    max-height: 95%;
    transform: translate(-50%, -50%) translate(-0.5px, -0.5px);
  `}
`;

export const ContainerWrapper = styled.article`
  ${({ theme }) => css`
    display: flex;
    /* top: 49.5%;
    left: 49.5%; */
    flex-direction: column;
    justify-content: space-between;
    width: calc(100% - (${theme.layout.section_side} * 2));
    height: 90%;
    overflow: hidden;
    border: 1px solid ${theme.stroke.stroke_2};
    border-radius: 32px;
    background: radial-gradient(72% 50% at 50% 50%, #777 0%, #000 100%);
    will-change: translate;
    backdrop-filter: blur(50px);
  `}
`;

export const Background = styled.div`
  ${({ theme }) => css`
    display: flex;
    position: fixed;
    z-index: ${theme.zIndex.background};
    top: 0;
    left: 0;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    overflow: hidden;
    border-radius: 16px;
    background: ${theme.backgroundColor.bg_dark_4_alpha};
    backdrop-filter: blur(10px);
  `}
`;

export const Inner = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

export const Avatar = styled.div`
  width: 100%;
  height: 100%;

  img {
    width: 100%;
    height: 100%;
    object-fit: scale-down;
  }
`;

export const Header = styled.header`
  ${({ theme }) => css`
    display: flex;
    position: absolute;
    top: ${theme.layout.section_side};
    left: 0;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 44px;
    padding: 0 ${theme.layout.section_side};
  `}
`;

export const CloseButtonBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
`;

export const CloseButton = styled.button`
  display: block;
`;

export const Profile = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 4px;
`;

export const Name = styled.div`
  ${({ theme }) => css`
    strong {
      ${theme.fontStyle.text.body16_bold}
    }
  `}
`;

export const ContentWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    position: absolute;
    bottom: ${theme.layout.section_side};
    left: 0;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    gap: 8px;
    padding: 0 ${theme.layout.section_side};
  `}
`;

export const ContentBox = styled.div`
  ${({ theme }) => css`
    img {
      width: 100%;
    }
  `}
`;

export const MotionButtonBox = styled.div`
  display: block;
  width: 100%;
`;

export const MotionButton = styled.button`
  ${({ theme }) => css`
    display: block;
    width: 100%;
    height: 44px;
    border: 1px solid ${theme.stroke.stroke_1};
    border-radius: 22px;
    background: ${theme.point.point_bg_5};
    color: #462600;
    font-family: Poppins 'serif';
    font-size: 18px;
    font-weight: 600;
    letter-spacing: -1%;
    line-height: 1.4;
  `}
`;
